/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * FAQ entry for competition page
 * @export
 * @interface CompetitionFaq
 */
export interface CompetitionFaq {
    /**
     * 
     * @type {string}
     * @memberof CompetitionFaq
     */
    question: string;
    /**
     * Can include HTML/markdown
     * @type {string}
     * @memberof CompetitionFaq
     */
    answer: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionFaq
     */
    order?: number;
}

/**
 * Check if a given object implements the CompetitionFaq interface.
 */
export function instanceOfCompetitionFaq(value: object): value is CompetitionFaq {
    if (!('question' in value) || value['question'] === undefined) return false;
    if (!('answer' in value) || value['answer'] === undefined) return false;
    return true;
}

export function CompetitionFaqFromJSON(json: any): CompetitionFaq {
    return CompetitionFaqFromJSONTyped(json, false);
}

export function CompetitionFaqFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionFaq {
    if (json == null) {
        return json;
    }
    return {
        
        'question': json['question'],
        'answer': json['answer'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function CompetitionFaqToJSON(json: any): CompetitionFaq {
    return CompetitionFaqToJSONTyped(json, false);
}

export function CompetitionFaqToJSONTyped(value?: CompetitionFaq | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question': value['question'],
        'answer': value['answer'],
        'order': value['order'],
    };
}

